import { writable } from 'svelte/store';
import { StorageKeys } from './enums/localStorageKeys';
export var Views;
(function (Views) {
    Views[Views["success"] = 0] = "success";
    Views[Views["checkout"] = 1] = "checkout";
    Views[Views["cart"] = 2] = "cart";
})(Views || (Views = {}));
;
export const sum = writable(0);
export const addToSum = (amount) => {
    sum.update(value => Math.round((value + amount) * 100) / 100);
};
export const logout = () => {
    localStorage.removeItem(StorageKeys.AccessToken);
    accessToken.set(undefined);
};
export const accessToken = writable(undefined);
export const selectedLanguageCode = writable('de');
export const currentPage = writable(Views.cart);
export const errorMessage = writable('');
